import React from 'react';
import { Modal, Button, Badge } from 'react-bootstrap';
import moment from 'moment';

const PolicyDetailsModal = ({ show, onHide, policy }) => {
  if (!policy) return null;

  // Format currency
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      maximumFractionDigits: 0
    }).format(amount);
  };

  // Status badge color
  const getStatusBadge = (status) => {
    switch(status?.toLowerCase()) {
      case 'approved': return 'success';
      case 'pending': return 'warning';
      case 'rejected': return 'danger';
      default: return 'primary';
    }
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton className="bg-light">
        <Modal.Title className="fw-bold">
          <i className="mdi mdi-file-document me-2"></i>
          Policy Details
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="py-4">
        <div className="row g-4">
          <div className="col-md-6">
            <div className="card h-100 border-0 shadow-sm">
              <div className="card-header bg-primary text-white">
                <h5 className="mb-0">Policy Information</h5>
              </div>
              <div className="card-body">
                <div className="mb-3">
                  <h6 className="text-muted small">Policy Number</h6>
                  <p className="fw-bold">{policy.policyNumber || 'N/A'}</p>
                </div>
                
                <div className="mb-3">
                  <h6 className="text-muted small">Plan Name</h6>
                  <p className="fw-bold">{policy.insurance_plan || 'N/A'}</p>
                </div>
                
                <div className="mb-3">
                  <h6 className="text-muted small">Coverage Amount</h6>
                  <p className="fw-bold">{formatCurrency(policy.sale_amount)}</p>
                </div>
                
                <div className="mb-3">
                  <h6 className="text-muted small">Status</h6>
                  <Badge pill bg={getStatusBadge(policy.status)} className="fs-6">
                    {policy.status || 'N/A'}
                  </Badge>
                </div>
                
                <div className="row">
                  <div className="col-6">
                    <h6 className="text-muted small">Start Date</h6>
                    <p className="fw-bold">
                      {policy.policyStartDate ? moment(policy.policyStartDate).format('DD MMM YYYY') : 'N/A'}
                    </p>
                  </div>
                  <div className="col-6">
                    <h6 className="text-muted small">End Date</h6>
                    <p className="fw-bold">
                      {policy.policyEndDate ? moment(policy.policyEndDate).format('DD MMM YYYY') : 'N/A'}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="col-md-6">
            <div className="card h-100 border-0 shadow-sm">
              <div className="card-header bg-info text-white">
                <h5 className="mb-0">Customer & Agent Information</h5>
              </div>
              <div className="card-body">
                <div className="mb-4">
                  <h6 className="text-primary mb-3">Customer Details</h6>
                  <div className="mb-2">
                    <i className="mdi mdi-account me-2"></i>
                    <span className="fw-bold">{policy.user_id?.fullName || 'N/A'}</span>
                  </div>
                  <div className="mb-2">
                    <i className="mdi mdi-email me-2"></i>
                    <span>{policy.user_id?.email || 'N/A'}</span>
                  </div>
                  <div>
                    <i className="mdi mdi-phone me-2"></i>
                    <span>{policy.user_id?.mobile || 'N/A'}</span>
                  </div>
                </div>
                
                <div>
                  <h6 className="text-primary mb-3">Agent Details</h6>
                  <div className="mb-2">
                    <i className="mdi mdi-account me-2"></i>
                    <span className="fw-bold">{policy.agent_id?.fullName || 'N/A'}</span>
                  </div>
                  <div className="mb-2">
                    <i className="mdi mdi-email me-2"></i>
                    <span>{policy.agent_id?.email || 'N/A'}</span>
                  </div>
                  <div>
                    <i className="mdi mdi-phone me-2"></i>
                    <span>{policy.agent_id?.mobile || 'N/A'}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        {policy.attachmentDocument && (
          <div className="mt-4 text-center">
            <h5 className="mb-3">Policy Documents</h5>
            <Button 
              variant="primary" 
              href={policy.attachmentDocument} 
              target="_blank"
              className="me-2"
            >
              <i className="mdi mdi-file-pdf me-2"></i>
              View Policy PDF
            </Button>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          <i className="mdi mdi-close me-2"></i>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PolicyDetailsModal;
